import gql from 'graphql-tag';

export const DELETE_STALL_PRODUCT_DISCOUNT = gql`
  mutation DeleteStallProductDiscount($discountId: ID!) {
    deleteStallProductDiscount(discountId: $discountId) {
      success
      error
    }
  }
`;
